// extracted by mini-css-extract-plugin
export default {"cls1":"Comment-cls1_zlE","cls2":"Comment-cls2_obE Comment-cls1_zlE"};